module.exports = __webpack_public_path__ + "img/credit-one-club-gal-13.5a56d154.jpg";